/**
 * The `board-grid` LevelKind (design §17) — paintable tile boards. Non-spatial in the
 * 3Cs sense (no kinematics), spatial in layout: the painter editor renders it as a grid.
 */
import type { LevelKind } from '../../types.js';
import { type BoardGridLevel, BoardGridLevelSchema } from './schema.js';
import { validateBoardGrid } from './validate.js';

export const boardGridLevelKind: LevelKind<BoardGridLevel> = {
  id: 'board-grid',
  schema: BoardGridLevelSchema,
  consumesThreeCs: false,
  view: 'grid',
  derivation: {
    genres: ['match-3'],
    mechanicHints: ['board', 'grid', 'tile', 'starting-layout', 'tactics-map'],
  },
  validate: validateBoardGrid,
};

export { BoardGridLevelSchema } from './schema.js';
export type { BoardGridLevel, BoardGridCell } from './schema.js';
